import { ITheme, IStyle, mergeStyleSets, getTheme } from '@fluentui/react';
import React from 'react';
import { IProductReview } from '../../../../entities-generated/common/product-review';
import { IProductTexture } from '../../../../entities-generated/common/product-texture';
import { noWrapStyle } from '../../../../framework/utils/no-wrap-style';
import { RatingBar } from '../../../components/rating-bar';
import { ProductVariantLabel } from '../pdct-variant-label';
import { PriceDisplay } from '../price';
import { BwjButton, BwjButtonType } from '../../../../framework/components/bwj-button';
import { fontFamily } from '../../../../app-core/app-theme';

interface IProductDetailPanelFooterProps {
  title: string;
  averageRating?: number | undefined;
  rating?: IProductReview | undefined;
  selectedVariant: IProductTexture | null;
  price: number | null;
  actionButtonText: string;
  onActionButtonClicked: () => void;
  variantDescriptor: string;
  variantOptionsVisible: boolean;
  selectVariantButtonText: string;
  onSelectVariantClicked: () => void;
}

const getStyleClasses = (theme: ITheme) => {
  const root: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '1rem',
    maxWidth: 1140,
    minWidth: 300,
    margin: '0 auto',
    fontFamily: fontFamily,
  };

  const contextContainer: IStyle = {
    width: 1,
    flexGrow: 1,
  };

  const variantContainer: IStyle = {
    marginTop: '0.75rem',
  };

  const buttonContainer: IStyle = {
    minWidth: '25%',

    '& > button': {
      minWidth: '100%',
    },
  };

  const title: IStyle = {
    ...noWrapStyle as unknown as {},
    fontSize: theme.fonts.medium.fontSize,
    lineHeight: theme.fonts.medium.lineHeight,
    fontWeight: 600,
    margin: 0,
    padding: 0,
  };

  return mergeStyleSets({
    root,
    contextContainer,
    title,
    variantContainer,
    buttonContainer,
  });
}

export const ProductDetailPanelFooter: React.FunctionComponent<IProductDetailPanelFooterProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);

  return (
    <div className={cs.root}>
      <div className={cs.contextContainer}>
        <h2 className={cs.title}>{props.title}</h2>
        {!!props.rating && !!props.averageRating && !props.selectedVariant &&
        <RatingBar
          rating={props.averageRating}
          reviewerCount={props.rating.totalReviewCount}
          rootStyle={{ marginTop: '0.75rem', width: '90%', maxWidth: 250 }}
        />}
        {!!props.selectedVariant &&
        <div className={cs.variantContainer}>
          <ProductVariantLabel
            texture={props.selectedVariant}
            size={1.4}
          />
        </div>}
      </div>
      {!!props.price &&
      <PriceDisplay
        price={props.price}
        fontSize={theme.fonts.xxLarge}
      />}
      <div className={cs.buttonContainer}>
        {(!!props.selectedVariant || props.variantOptionsVisible) &&
        <BwjButton
          buttonStyle={BwjButtonType.PrimaryStandard}
          text={props.actionButtonText}
          disabled={!props.selectedVariant}
          onClick={props.onActionButtonClicked}
        />}
        {!props.selectedVariant && props.variantOptionsVisible === false &&
        <BwjButton
          buttonStyle={BwjButtonType.PrimaryStandard}
          text={props.selectVariantButtonText}
          onClick={props.onSelectVariantClicked}
        />}
      </div>
    </div>
  );
};
